module.exports = __webpack_public_path__ + "img/color-7.032154d.png";